export default __webpack_public_path__ + "64413ad8a360f3c2887cac7dccb470a9.png";